import Vue from 'vue';

Vue.filter('EMPTY_FULL', (value: any) => {
    if (!value) { return 'Uppgift saknas'; }
    return value;
});

Vue.filter('EMPTY', (value: any) => {
    if (!value) { return 'Saknas'; }
    return value;
});

Vue.filter('DATE', (value: any) => {
    if (!value) { return ''; }
    if (value.length === 8) {
        return `${value.substr(0, 4)}-${value.substr(4, 2)}-${value.substr(6, 2)}`;
    }
    return value;
});

Vue.filter('ORGNR', (value: any) => {
    if (!value) { return ''; }
    if (value.length === 10) {
        return `${value.substr(0, 6)}-${value.substr(6, 10)}`;
    }
    return value;
});

Vue.filter('ZIP', (value: any) => {
    if (!value) { return ''; }
    if (value.length === 5) {
        return `${value.substr(0, 3)} ${value.substr(3, 5)}`;
    }
    return value;
});

const d0 = (value: any) => {
    if (value === 0) { return '0'; }
    if (!value) { return ''; }
    value = value.toString();
    return Number(value).toLocaleString('sv-SE', {maximumFractionDigits: 0});
};
Vue.filter('D0', d0);

const d1 = (value: any) => {
    if (value === 0) { return '0'; }
    if (!value) { return ''; }
    value = value.toString();
    return Number(value).toLocaleString('sv-SE', {maximumFractionDigits: 1, minimumFractionDigits: 1});
};
Vue.filter('D1', d1);

Vue.filter('D2', (value: any) => {
    if (value === 0) { return '0'; }
    if (!value) { return ''; }
    value = value.toString();
    return Number(value).toLocaleString('sv-SE', {maximumFractionDigits: 2, minimumFractionDigits: 2});
});

Vue.filter('P', (value: any) => {
    if (!value && value !== 0) { return ''; }
    return (value * 100).toLocaleString('sv-SE', {maximumFractionDigits: 1, minimumFractionDigits: 1}) + ' %';
});

Vue.filter('P0', (value: any) => {
    if (!value && value !== 0) { return ''; }
    return (value * 100).toLocaleString('sv-SE', {maximumFractionDigits: 0, minimumFractionDigits: 0}) + ' %';
});

Vue.filter('tkr', (value: any) => {
    if (!value) { return 'N/A'; }
    return value.toString() + ' tkr';
});

Vue.filter('TKR', (value: any) => {
    if (!value) { return 'N/A'; }
    return d0(value) + ' tkr';
});

Vue.filter('MKR', (value: any) => {
    if (!value) { return 'N/A'; }
    value /= 1000;
    if (value >= 10) {
        return d0(value) + ' mkr';
    } else {
        return d1(value) + ' mkr';
    }
});

Vue.filter('KR', (value: any) => {
    const numericSymbols = [' mkr', ' mdr'];
    let i = 2;
    if (value >= 1000) {
        while (i--) {
            const multi = Math.pow(1000, i + 1);
            if (value >= multi && numericSymbols[i] !== null) {
                return (value / multi) + numericSymbols[i];
            }
        }
    }
    return (value) + ' tkr';
});

Vue.filter('TS', (value: any) => {
    if (!value) { return ''; }
    return `${value.substr(0, 10)}`;
});

Vue.filter('TS2', (value: any) => {
    if (!value) { return ''; }
    return `${value.substr(0, 16)}`;
});

Vue.filter('sign', (value: any) => {
    if (value > 0) { return `+${value}`; }
    return value;
});
